import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { useAuthenticate } from "../api/effects/mutations/User/authenticate";
import HeaderGuest from "../components/Header/HeaderGuest";
import { WarningModal } from "../components/WarningModal";

const RootGrid = styled(Grid)(({ theme }) => ({
  height: "90vh",
  backgroundImage: `url(${process.env.PUBLIC_URL}/images/BackgroundJob.svg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  [theme.breakpoints.down("sm")]: {
    backgroundSize: "cover",
  },
}));

const SquareGrid = styled(Grid)({
  backgroundColor: "#FFF",
  height: "auto",
  width: "100%",
  maxWidth: "90vw",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "2%",
});

const ClearLink = styled(Link)({
  color: "#150A33",
  textDecoration: "none",
  fontSize: ".8em",
  padding: "3%",
});

const ItemGrid = styled(Grid)({
  width: "100%",
  textAlign: "center",
});

const ItemTitleGrid = styled(Grid)({
  width: "100%",
  textAlign: "center",
  paddingBottom: "4vh",
});

const ButtonFull = styled(Button)({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
});

const TextFieldFull = styled(TextField)({
  width: "90%",
});

export default function AuthenticatePage() {
  const { token } = useParams();

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState("");

  const { mutateAsync: Authenticate } = useAuthenticate({
    onSuccess(data) {
      setWarningModalText(data);
      setWarningModalState(true);
      console.log("Success");
    },
    onError(data: any) {
      setWarningModalText(data.response.data);
      setWarningModalState(true);
      console.log("Error");
    },
  });

  useEffect(() => {
    if (token !== undefined) Authenticate({ token: token });
  }, []);

  const navigate = useNavigate();

  const handleCloseNavigate = () => {
    setWarningModalState(false);
    navigate("/");
  };

  return (
    <>
      <HeaderGuest />
      <WarningModal
        open={warningModalState}
        handleClose={handleCloseNavigate}
        text={warningModalText}
      />
      <RootGrid container justifyContent="center" alignItems="center">
        <SquareGrid
          item={true}
          xs={12}
          sm={9}
          md={6}
          lg={3}
          spacing={1}
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
        >
          <ItemTitleGrid item>
            {warningModalState ? (
              <span />
            ) : (
              <Typography variant="h4">Checking Link ...</Typography>
            )}
          </ItemTitleGrid>
        </SquareGrid>
      </RootGrid>
    </>
  );
}
